export function stripTypenames(obj: any) {
	return stripPropertyRecursively(obj, '__typename');
}

export function stripPropertyRecursively(obj: any, propToDelete: string) {
	if (!obj || typeof obj !== 'object') return obj;
	if (Array.isArray(obj)) return obj.map(a => stripPropertyRecursively(a, propToDelete));
	return Object.keys(obj)
		.filter(f => f !== propToDelete)
		.reduce((prev, c) => ({ ...prev, [c]: stripPropertyRecursively(obj[c], propToDelete) }), {});
}
